import script from "./MandateEmailModal.vue?vue&type=script&setup=true&lang=js"
export * from "./MandateEmailModal.vue?vue&type=script&setup=true&lang=js"

import "./MandateEmailModal.vue?vue&type=style&index=0&id=dc4f876c&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dc4f876c"]])

export default __exports__